/* @flow */

import * as types from 'src/shared/domain/user/action/userActionTypes';
import { createReducer } from 'src/shared/core/util/reducerUtils';

/*
|------------------------------------------------------------------------------
| INITIAL STATE
|------------------------------------------------------------------------------
*/

const initialState = {
  isAvatarUploading: false,
  hasAvatarUploadFailed: false,
};

/*
|------------------------------------------------------------------------------
| REDUCERS
|------------------------------------------------------------------------------
*/

const _handleAvatarUploadRequest = (state: Object): Object => ({
  ...state,
  isAvatarUploading: true,
  hasAvatarUploadFailed: false,
});

const _handleAvatarUploadSuccess = (state: Object): Object => ({
  ...state,
  isAvatarUploading: false,
  hasAvatarUploadFailed: false,
});

const _handleAvatarUploadFailure = (state: Object): Object => ({
  ...state,
  isAvatarUploading: false,
  hasAvatarUploadFailed: true,
});

/*
|------------------------------------------------------------------------------
| REDUCER
|------------------------------------------------------------------------------
*/

export default createReducer(initialState, {
  [types.UPDATE_AVATAR_REQUEST]: _handleAvatarUploadRequest,
  [types.UPDATE_AVATAR_SUCCESS]: _handleAvatarUploadSuccess,
  [types.UPDATE_AVATAR_FAILURE]: _handleAvatarUploadFailure,
});
